import { useExperiencesContext } from '../../experiences/Experiences';
import { useHeaderPeepingContext } from '../../../context/PlpContext';

export const useStickyControlsData = () => {
  const { isProductCardSizeFlagOn, isSingleColumnLayout } =
    useExperiencesContext();
  const { isHeaderPeeping } = useHeaderPeepingContext();

  return {
    isHeaderPeeping,
    isProductCardSizeFlagOn,
    isSingleColumnLayout,
  };
};
